<template>
  <div
    id="page-loader"
    :class="className"
  >
    <div className="lds-ripple">
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PageLoader",
    props: {
      show: Boolean,
    },
    computed: {
      className() {
        return this.show ? "show" : "";
      },
    },
  };
</script>

<style lang="scss" scoped>
  #page-loader {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(20, 20, 20, 0.774);
    z-index: 10000;
    opacity: 0;
    transition: all ease-in-out 0.5s;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;

    &.show {
      opacity: 1;
      visibility: visible;
    }

    #page-loader .text {
      font-size: 18px;
      animation: fadeOut infinite 1s ease-out;
    }

    .lds-ripple {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;
    }
    .lds-ripple div {
      position: absolute;
      border: 4px solid #ffcc00;
      opacity: 1;
      border-radius: 50%;
      animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }
    .lds-ripple div:nth-child(2) {
      animation-delay: -0.7s;
    }
  }

  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
    100% {
      opacity: 1;
    }
  }
</style>